var _defs, _circle, _g, _rect, _rect2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c1f81;}.cls-2{fill:#ff8f0b;}.cls-3{fill:#eaeced;}.cls-4,.cls-5,.cls-6,.cls-7{fill:none;}.cls-5,.cls-6,.cls-7{stroke:#fff;stroke-linecap:round;}.cls-5,.cls-6{stroke-miterlimit:10;}.cls-5{stroke-width:4px;}.cls-6{stroke-width:5px;}.cls-7{stroke-miterlimit:10;stroke-width:5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-1",
    cx: 56.94,
    cy: 56.94,
    r: 56.94
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_149",
    "data-name": "Path 149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.73,109.45A51.67,51.67,0,0,1,36.62,10.2,51.65,51.65,0,0,1,93.25,94.32a51.39,51.39,0,0,1-36.52,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.73,8.14A49.67,49.67,0,0,0,37.4,103.55,49.67,49.67,0,0,0,76.05,12a49.26,49.26,0,0,0-19.32-3.9m0-4A53.66,53.66,0,1,1,3.07,57.8,53.66,53.66,0,0,1,56.73,4.14Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    className: "cls-4",
    x: 32,
    y: 30.21,
    width: 48.82,
    height: 54.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    className: "cls-4",
    x: 26.84,
    y: 30.21,
    width: 59.47,
    height: 54.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-5",
    d: "M78.76,75a25.92,25.92,0,1,1-2-36.6,25.17,25.17,0,0,1,2.89,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-1",
    d: "M47.29,59.29,52.87,55l5.58-4.3.94,7,.94,7L53.81,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-1",
    d: "M70.76,56l-5.58,4.31L59.6,64.65l-.94-7-.94-7,6.52,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-6",
    d: "M71.56,42.84A23.28,23.28,0,0,0,55.71,40c-5.61.89-9.26,3.52-13,7.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-7",
    d: "M43.52,69.27A23.31,23.31,0,0,0,58.11,76.1c5.65.59,9.86-1,14.58-4.16"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/Icon7.59e5f235d359673fa252c316b7177ac0.svg";
export { ForwardRef as ReactComponent };